import request from "../../helpers/request"

export const getCentralByLoja = async (idLoja: string) => {
  if(!idLoja) return null
  const url = `${process.env.REACT_APP_API}/DispCentral/GetbyIdLoja/${idLoja}`
  const result =  await request({ url })
  return result.data
}